import { BalanceEmpleado } from '../tipos/vacaciones';
import { API_ENDPOINTS } from '../config/apiConfig';
import { fetchJson, putJson } from './api';

/**
 * Obtiene todos los balances para un anio especifico.
 */
export function getAllByAnio(anio: number): Promise<BalanceEmpleado[]> {
  return fetchJson<BalanceEmpleado[]>(
    `${API_ENDPOINTS.balances}?anio=${anio}`
  );
}

/**
 * Obtiene el balance de un empleado especifico para un anio dado.
 */
export function getByEmpleado(empleadoId: number, anio: number): Promise<BalanceEmpleado> {
  return fetchJson<BalanceEmpleado>(
    `${API_ENDPOINTS.balances}/empleado/${empleadoId}?anio=${anio}`
  );
}

/**
 * Actualiza los dias totales de un empleado para un anio dado.
 * El backend recalcula los dias restantes automaticamente.
 */
export const updateDiasTotales = (empleadoId: number, anio: number, diasTotales: number): Promise<BalanceEmpleado> =>
  putJson<BalanceEmpleado>(`${API_ENDPOINTS.balances}/empleado/${empleadoId}?anio=${anio}`, { diasTotales });
